import { Card, type CardProps, Space, Typography } from 'antd';
import styled from 'styled-components';
import LoginLogo from '../../pages/login/SignInPage/LoginLogo';
import breakpoints from '../../utilities/breakpoints';

export type LoginContentProps = Pick<CardProps, 'children' | 'title'> & {
    description?: string;
};

const StyledSpace = styled(Space)`
    width: 100%;

    & > .ant-space-item {
        width: 100%;
    }
`;

const Title = styled(Typography.Title)`
    font-size: 20px;
    text-align: center;
`;

const Description = styled(Typography.Text)`
    font-size: 16px;
    font-weight: bold;
    display: flex;
    text-align: center;
`;

const RootContainer = styled.div`
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const MainContainer = styled(Card)`
    width: 100%;
    padding: 20px;
    box-sizing: content-box;

    h4.ant-typography {
        color: ${({ theme }) => `${theme.loginTheme.titleColor};`};
        margin-bottom: 0;
    }

    @media (min-width: ${breakpoints.sm}) {
        width: 24rem;
    }
`;

const LoginContent = ({ title, description, children }: LoginContentProps) => (
    <RootContainer>
        <MainContainer bordered={false}>
            <StyledSpace align="center" direction="vertical" size={24}>
                <LoginLogo />
                {title && <Title level={4}>{title}</Title>}
                {description && <Description>{description}</Description>}
                {children}
            </StyledSpace>
        </MainContainer>
    </RootContainer>
);

export default LoginContent;
